import React from 'react';

import { StyledWrapper, StyledErrorBox, StyledHeading, StyledText } from './ErrorBoundary.styles';
import { StyledButton } from '../ButtonCta/ButtonCta.styles';
import { errorLabels, userLabels } from '../../lib/labels';

const ErrorPage = () => (
  <StyledErrorBox>
    <StyledHeading>{errorLabels.genericAlternate}</StyledHeading>
    <StyledText>{errorLabels.contactCustomerSupport}</StyledText>
    <StyledButton onClick={(e) => (document.location = '/')}>
      {userLabels.backToHomeAlternate}
    </StyledButton>
  </StyledErrorBox>
);

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: '' };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <StyledWrapper hasLightBg>
          <ErrorPage />
        </StyledWrapper>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
